import { HOST_URL } from '../config'
import { HttpStatus } from '../constants/http-status.enum'
import type { ApiResponse } from './index'

export interface IUser {
    id: number
    username: string
    userNumber?: number
    password?: string
    isActive?: boolean
    roleNames?: string[]
    permissionKeys?: string[]
    deniedPermissionKeys?: string[]
    sessionId?: string
}

export async function signup(username: IUser['username'], password: IUser['password']): Promise<ApiResponse<IUser>> {
    const response = await fetch(`${HOST_URL}signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
            username,
            password,
        }),
    })
    const result = (await response.json()) as ApiResponse<IUser>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function login(username: IUser['username'], password: IUser['password'], rememberMe: boolean = true): Promise<ApiResponse<IUser>> {
    const response = await fetch(`${HOST_URL}login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
            username,
            password,
            rememberMe,
        }),
    })
    const result = (await response.json()) as ApiResponse<IUser>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function getSessionUser(): Promise<ApiResponse<IUser>> {
    const response = await fetch(`${HOST_URL}session-user`, {
        method: 'POST',
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<IUser>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function logout(): Promise<ApiResponse<IUser>> {
    const response = await fetch(`${HOST_URL}logout`, {
        method: 'POST',
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<IUser>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
